import { api, getAccessToken } from "../../lib/api";

export interface Interest {
  id: string;
  opportunityId: string;
  opportunityTitle: string | null;
  userId: string | null;
  userEmail: string | null;
  fullName: string | null;
  phone: string | null;
  email: string | null;
  amountIntended: string | null;
  message: string | null;
  status: "new" | "contacted" | "qualified" | "converted" | "rejected";
  assignedTo: string | null;
  source: string;
  contactedAt: string | null;
  internalNotes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface Activity {
  id: string;
  action: string;
  fromStatus: string | null;
  toStatus: string | null;
  comment: string | null;
  createdAt: string;
}

export interface Funnel {
  total: number;
  byStatus: Record<string, number>;
}

export const listInterests = (params: { status?: string; opportunityId?: string }) => {
  const qs = new URLSearchParams();
  if (params.status) qs.set("status", params.status);
  if (params.opportunityId) qs.set("opportunityId", params.opportunityId);
  return api<{ data: Interest[]; nextCursor: string | null }>(
    `/admin/interests?${qs.toString()}`,
  ).then((r) => r.data);
};

export const updateInterest = (
  id: string,
  body: { status?: string; internalNotes?: string | null; comment?: string | null },
) =>
  api<{ interest: Interest }>(`/admin/interests/${id}`, { method: "PATCH", body }).then(
    (r) => r.interest,
  );

export const interestActivities = (id: string) =>
  api<{ data: Activity[] }>(`/admin/interests/${id}/activities`).then((r) => r.data);

export const funnelStats = () => api<Funnel>("/admin/interests/stats");

export async function downloadInterestsCsv(): Promise<void> {
  const res = await fetch("/api/v1/admin/interests/export", {
    headers: { authorization: `Bearer ${getAccessToken() ?? ""}` },
  });
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `prospects-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
